/* ============================================================
   Dumpling Squishy Advent Calendar — fiche produit et panier
   ============================================================
   Aucun prix n est calcule pour etre facture : chaque offre est une
   variante Shopify (1, 3 ou 5 calendriers) avec son propre prix, ajoutee
   en quantite 1. Le panier et le checkout affichent donc le prix calcule
   par Shopify. Rien n est ajoute sans action du client : pas de
   protection, pas d option precochee.
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("dp");
  if (!root) return;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var DATA = {};
  try { DATA = JSON.parse($("[data-dp-product]", root).textContent); } catch (e) { return; }
  var PAR_ID = {};
  (DATA.variants || []).forEach(function (v) { PAR_ID[String(v.id)] = v; });

  /* ------------------------------------------------------------ outils */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = DATA.moneyFormat || "${{amount}}";
    return f
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","));
  }
  function esc(t) { var d = document.createElement("div"); d.textContent = t == null ? "" : String(t); return d.innerHTML; }
  function annoncer(t) { var z = $("[data-dp-live]", root); if (z) z.textContent = t; }

  /* Jours ouvres (samedi et dimanche exclus), comme le reste du site. */
  function ouvres(depart, n) {
    var d = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function court(d, jour) {
    var o = { month: "short", day: "numeric" };
    if (jour) o.weekday = "short";
    try { return d.toLocaleDateString("en-US", o); } catch (e) { return (d.getMonth() + 1) + "/" + d.getDate(); }
  }
  function fenetre(min, max) {
    min = parseInt(min, 10); max = parseInt(max, 10);
    if (isNaN(min) || isNaN(max) || min < 0 || max < min) return null;
    var auj = new Date();
    return court(ouvres(auj, min)) + " – " + court(ouvres(auj, max));
  }

  /* ------------------------------------------------------------ offres */
  var form = document.getElementById("dp-form");
  var radios = $$("input[name='id']", form);

  function choisie() {
    var r = radios.filter(function (x) { return x.checked; })[0] || radios[0];
    return r ? PAR_ID[String(r.value)] : null;
  }

  function maj() {
    var v = choisie();
    radios.forEach(function (r) { r.closest(".dp-offer").classList.toggle("is-on", r.checked); });
    if (!v) return;
    var nom = v.n > 1 ? v.n + " calendars" : "1 calendar";
    var l1 = $("[data-dp-add-label]", root); if (l1) l1.textContent = "Add " + nom + " to cart";
    var l2 = $("[data-dp-add-amt]", root); if (l2) l2.textContent = "— " + money(v.price);
    var s1 = $("[data-dp-sticky-label]", root); if (s1) s1.textContent = v.label + (v.n > 1 ? " · " + nom : "");
    var s2 = $("[data-dp-sticky-price]", root); if (s2) s2.textContent = money(v.price);
    var xp = $("[data-dp-express-id]", root); if (xp) xp.value = v.id;
    var add = $("[data-dp-add]", root);
    if (add) add.disabled = !v.available;
  }
  radios.forEach(function (r) {
    r.addEventListener("change", function () {
      maj();
      var v = choisie();
      if (v) annoncer(v.label + ", " + money(v.price));
    });
  });

  function allerAuxOffres() {
    var o = $(".dp-offers", root);
    if (o) o.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  $$("[data-dp-to-offers]", root).forEach(function (b) { b.addEventListener("click", allerAuxOffres); });
  $$("[data-dp-pick]", root).forEach(function (b) {
    b.addEventListener("click", function () {
      var r = radios.filter(function (x) { return x.value === b.getAttribute("data-dp-pick"); })[0];
      if (r && !r.disabled) { r.checked = true; maj(); }
      allerAuxOffres();
    });
  });

  /* ------------------------------------------------------------ galerie */
  var track = $("[data-dp-track]", root);
  var dots = $$("[data-dp-dots] button, [data-dp-thumbs] button", root);
  function majDots() {
    if (!track || !dots.length) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    dots.forEach(function (d, k) { d.setAttribute("aria-current", k === i ? "true" : "false"); });
  }
  if (track) {
    track.addEventListener("scroll", function () { requestAnimationFrame(majDots); }, { passive: true });
    /* Position = index x largeur de la photo : juste meme avec la marge
       autour de la galerie (offsetLeft, lui, l incluait). */
    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        var i = parseInt(d.getAttribute("data-i"), 10);
        if (isNaN(i)) return;
        dots.forEach(function (x, k) { x.setAttribute("aria-current", k === i ? "true" : "false"); });
        track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
      });
    });
    majDots();
  }

  /* ---------------------------------------------------------- livraison */
  var eta = $("[data-dp-eta]", root);
  if (eta) {
    var f = fenetre(eta.getAttribute("data-min"), eta.getAttribute("data-max"));
    if (f) eta.textContent = eta.getAttribute("data-label") + ": " + f + " (" +
      eta.getAttribute("data-min") + "–" + eta.getAttribute("data-max") + " business days)";
  }

  /* Date limite reelle : derniere date de commande dont la fin de fenetre
     de livraison tombe AVANT la date cible (ex. 1er decembre). Calculee
     avec le delai maximum ; disparait une fois depassee. Aucun compteur. */
  var by = $("[data-dp-by]", root);
  if (by) {
    var m = /^(\d{1,2})-(\d{1,2})$/.exec(by.getAttribute("data-date") || "");
    var max = parseInt(by.getAttribute("data-max"), 10);
    if (m && !isNaN(max)) {
      var auj = new Date();
      var cible = new Date(auj.getFullYear(), Number(m[1]) - 1, Number(m[2]));
      var limite = null;
      var d = new Date(auj.getFullYear(), auj.getMonth(), auj.getDate());
      for (var k = 0; k < 120 && ouvres(d, max) < cible; k++) {
        limite = new Date(d.getTime());
        d.setDate(d.getDate() + 1);
      }
      if (limite) {
        by.textContent = "Order by " + court(limite, true) + " to have it before " + court(cible) + ".";
        by.hidden = false;
      }
    }
  }

  /* ============================================================= panier */
  var tiroir = $("[data-dp-drawer]", root);
  var scrim = $("[data-dp-scrim]", root);
  var corps = $("[data-dp-dw-body]", root);
  var pied = $("[data-dp-dw-foot]", root);
  var wallets = $("[data-dp-wallets]", root);
  var tiroirOuvert = false;
  var retour = null;

  function reglage(n, d) { var v = tiroir && tiroir.getAttribute(n); return v === null || v === "" ? d : v; }
  function estCadeau(l) { var p = l.properties || {}; return p._mirthly_free_gift === "true" || p._mirthly_free_gift === true; }
  /* Nombre de calendriers dans une unite de la ligne (« 3 calendars » = 3). */
  function parUnite(l) { var m = /(\d+)\s*calendars?/i.exec(l.variant_title || ""); return m ? Number(m[1]) : 1; }

  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function changer(key, q) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: q })
    }).then(function (r) { return r.json(); });
  }
  /* Un cadeau ajoute automatiquement ailleurs sur le site n est jamais
     facture : s il ne passe plus a 0 $, on le retire. */
  function nettoyer(cart) {
    var c = (cart.items || []).filter(function (l) { return estCadeau(l) && l.final_line_price > 0; })[0];
    return c ? changer(c.key, 0).then(getCart) : Promise.resolve(cart);
  }

  function majCompteur(cart) {
    var n = (cart.items || []).reduce(function (s, l) { return s + (estCadeau(l) ? 0 : l.quantity); }, 0);
    $$("[data-dp-count]", root).forEach(function (e) { e.textContent = String(n); });
    var c = $("[data-dp-dw-count]", root); if (c) c.textContent = n ? "(" + n + ")" : "";
  }

  function peindre(cart) {
    majCompteur(cart);
    if (!corps || !pied) return;
    var items = cart.items || [];
    if (!items.length) {
      corps.innerHTML = '<div class="dp-empty"><h3>Your cart is empty</h3><p>Pick an offer to get started.</p></div>';
      pied.innerHTML = '<button type="button" class="dp-cta" data-dp-keep>Keep shopping</button>';
      $("[data-dp-keep]", pied).addEventListener("click", fermer);
      if (wallets) wallets.hidden = true;
      return;
    }

    var calendriers = 0, economie = 0;
    corps.innerHTML = items.map(function (l) {
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      var cadeau = estCadeau(l);
      var offre = PAR_ID[String(l.variant_id)];
      var vt = l.variant_title && l.variant_title !== "Default Title" ? l.variant_title : "";
      var sous = "";
      if (offre) {
        calendriers += offre.n * l.quantity;
        var plein = DATA.unit * offre.n * l.quantity;
        if (plein > l.final_line_price) economie += plein - l.final_line_price;
        sous = esc(offre.label) + (offre.n > 1 ? ' · <em>' + offre.n + " calendars</em>" : "");
      } else if (!cadeau) {
        if (/calendar/i.test(vt)) calendriers += parUnite(l) * l.quantity;
        sous = esc(vt);
      }
      var barre = "";
      if (offre && offre.n > 1 && DATA.unit * offre.n * l.quantity > l.final_line_price) {
        barre = "<s>" + money(DATA.unit * offre.n * l.quantity) + "</s>";
      } else if (l.original_line_price > l.final_line_price) {
        barre = "<s>" + money(l.original_line_price) + "</s>";
      }
      return '<div class="dp-line">' +
        '<div class="dp-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : "") + "</div>" +
        "<div>" +
          '<p class="dp-line__t">' + esc(l.product_title) + "</p>" +
          (sous ? '<p class="dp-line__v">' + sous + "</p>" : "") +
          (cadeau ? (l.final_line_price === 0 ? '<span class="dp-free">FREE GIFT</span>' : "") :
            '<span class="dp-qty"><button type="button" data-k="' + esc(l.key) + '" data-q="' + (l.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            "<span>" + l.quantity + "</span>" +
            '<button type="button" data-k="' + esc(l.key) + '" data-q="' + (l.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
            '<button type="button" class="dp-rm" data-k="' + esc(l.key) + '" data-q="0">Remove</button>') +
        "</div>" +
        '<div class="dp-line__p">' + money(l.final_line_price) + barre + "</div>" +
      "</div>";
    }).join("");

    $$("[data-k]", corps).forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.disabled) return;
        $$("[data-k]", corps).forEach(function (x) { x.disabled = true; });
        changer(b.getAttribute("data-k"), parseInt(b.getAttribute("data-q"), 10))
          .then(nettoyer).then(peindre).catch(function () { return rafraichir(); });
      });
    });

    var eta2 = fenetre(reglage("data-eta-min", "7"), reglage("data-eta-max", "14"));
    pied.innerHTML =
      (calendriers > 0 ? '<div class="dp-sum"><span>You receive</span><span><b>' + calendriers + " calendar" + (calendriers > 1 ? "s" : "") + "</b></span></div>" : "") +
      (economie > 0 ? '<div class="dp-sum"><span>Bundle savings</span><span class="ok">&minus;' + money(economie) + "</span></div>" : "") +
      '<div class="dp-sum"><span>Shipping</span><span class="ok">' + esc(reglage("data-ship", "Free")) + "</span></div>" +
      '<div class="dp-sum tot"><span>Total</span><span>' + money(cart.total_price) + "</span></div>" +
      '<a class="dp-cta" href="/checkout" data-dp-checkout>Checkout &mdash; ' + money(cart.total_price) + ' <span aria-hidden="true">&rarr;</span></a>' +
      (eta2 ? '<p class="dp-meta">📦 ' + esc(reglage("data-eta-label", "Estimated delivery")) + ": " + esc(eta2) + "</p>" : "") +
      '<div class="dp-dw__pay"><span class="dp-pay__icons"></span><span>🔒 ' + esc(reglage("data-secure", "Secure checkout")) + "</span></div>";
    var modele = $("[data-dp-pay-icons]", root);
    var ic = $(".dp-pay__icons", pied);
    if (modele && modele.content && ic) ic.appendChild(modele.content.cloneNode(true));
    var co = $("[data-dp-checkout]", pied);
    if (co) co.addEventListener("click", function () { co.textContent = "Redirecting…"; });
    if (wallets) wallets.hidden = !wallets.children.length;
  }

  function rafraichir() { return getCart().then(nettoyer).then(peindre).catch(function () {}); }

  function ouvrir() {
    retour = document.activeElement;
    tiroirOuvert = true;
    if (sticky) sticky.classList.remove("on");
    tiroir.classList.add("on"); scrim.classList.add("on");
    tiroir.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var x = $("[data-dp-close-cart]", tiroir);
    setTimeout(function () { if (x) x.focus(); }, 60);
    return rafraichir();
  }
  function fermer() {
    tiroirOuvert = false;
    tiroir.classList.remove("on"); scrim.classList.remove("on");
    tiroir.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (retour && retour.focus) retour.focus();
    majSticky();
  }

  /* --------------------------------------------------------------- ajout */
  var occupe = false;
  function ajouter() {
    var v = choisie();
    if (!v || occupe || !v.available) return;
    occupe = true;
    var btns = [$("[data-dp-add]", root), $("[data-dp-sticky-add]", root)].filter(Boolean);
    var lab = $("[data-dp-add-label]", root);
    btns.forEach(function (b) { b.disabled = true; });
    if (lab) lab.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Error"); return j; }); })
      .then(function () {
        var cb = $(".dp-cartbtn", root); if (cb) { cb.classList.remove("pop"); void cb.offsetWidth; cb.classList.add("pop"); }
        return ouvrir();
      })
      .catch(function (err) { alert("Sorry — this item could not be added. " + (err && err.message ? err.message : "")); })
      .then(function () { occupe = false; btns.forEach(function (b) { b.disabled = false; }); maj(); });
  }
  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); ajouter(); });
  var sAdd = $("[data-dp-sticky-add]", root);
  if (sAdd) sAdd.addEventListener("click", ajouter);

  /* ------------------------------------------------------- barre fixe */
  var sticky = $("[data-dp-sticky]", root);
  var cta = $("[data-dp-add]", root);
  var ctaVu = true;
  function majSticky() {
    if (!sticky) return;
    var on = !ctaVu && !tiroirOuvert;
    sticky.classList.toggle("on", on);
    sticky.setAttribute("aria-hidden", on ? "false" : "true");
    if (sAdd) sAdd.tabIndex = on ? 0 : -1;
  }
  /* La barre apparait des que le bouton principal n est pas a l ecran
     (pas encore atteint ou deja depasse) : un bouton d achat reste
     toujours visible. Calcul au defilement. */
  function calcSticky() {
    if (!sticky || !cta) return;
    var r = cta.getBoundingClientRect();
    ctaVu = r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    majSticky();
  }
  /* Calcul direct (une mesure par evenement, tres leger) : rien ne reste
     en attente si le navigateur suspend les animations. */
  window.addEventListener("scroll", calcSticky, { passive: true });
  window.addEventListener("resize", calcSticky);
  calcSticky();

  if (tiroir) {
    $$("[data-dp-open-cart]", root).forEach(function (b) { b.addEventListener("click", ouvrir); });
    $$("[data-dp-close-cart]", root).forEach(function (b) { b.addEventListener("click", fermer); });
    if (scrim) scrim.addEventListener("click", fermer);
    document.addEventListener("keydown", function (e) {
      if (!tiroirOuvert) return;
      if (e.key === "Escape") { fermer(); return; }
      if (e.key !== "Tab") return;
      var f2 = $$('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])', tiroir)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f2.length) return;
      if (e.shiftKey && document.activeElement === f2[0]) { e.preventDefault(); f2[f2.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f2[f2.length - 1]) { e.preventDefault(); f2[0].focus(); }
    });
  }

  /* ------------------------------------------------------------ depart */
  maj();
  getCart().then(majCompteur).catch(function () {});
})();
